import envConfig from "./environment.js";

function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
// 加载CSS
function loadCss(url) {
  return new Promise((resolve, reject) => {
    // 如果已经加载过，就不再重复插入
    if (document.querySelector(`link[href="${url}"]`)) {
      resolve();
      return;
    }

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = url;

    link.onload = () => resolve();
    link.onerror = () => reject(new Error(`CSS 加载失败: ${url}`));

    document.head.appendChild(link);
  });
}
// 加载JS文件
function loadScript(url) {
  return new Promise((resolve, reject) => {
    // 检查脚本是否已经加载过，避免重复加载
    if (document.querySelector(`script[src="${url}"]`)) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = url;
    script.type = "text/javascript";

    // 对于现代浏览器，可以设置async为false确保顺序执行
    // 如果需要异步加载可以设为true
    script.async = false;

    // 加载成功的回调
    script.onload = () => resolve();

    // 加载失败的回调
    script.onerror = () => reject(new Error(`Script 加载失败: ${url}`));

    // 将脚本添加到head或body中
    document.head.appendChild(script);
  });
}

let idName = ''

// 初始化加载文件
export async function init() {
  try {
    idName = uuid()
    if (!document.getElementById(idName)) {
      const div = document.createElement('div');
      div.id = idName;
      document.body.appendChild(div);
    }
    await loadCss("https://js.bosum.com/verify-sdk/verify.css");
    // console.log("verify.css 加载成功");

    if (!window.$) {
      await loadScript("https://js.bosum.com/verify-sdk/jquery.min.js");
      console.log("jquery 加载成功");
    }
    if (!window.CryptoJS) {
      await loadScript("https://js.bosum.com/verify-sdk/crypto-js.js");
      console.log("CryptoJS 加载成功");
    }

    // await loadScript("https://js.bosum.com/verify-sdk/crypto-js.js");
    // // console.log("crypto 加载成功");

    await loadScript("https://js.bosum.com/verify-sdk/ase.js");
    // console.log("ase.js 加载成功");

    await loadScript("https://js.bosum.com/verify-sdk/verify.js");




    // 压缩包
    // await loadScript("https://js.bosum.com/verify-sdk/crypto-js.min.js");
    // console.log("crypto 加载成功");

    // await loadScript("https://js.bosum.com/verify-sdk/ase.js");
    // // console.log("ase.js 加载成功");

    // await loadScript("https://js.bosum.com/verify-sdk/verify.min.js");
    // console.log("verify 加载成功");
    // 返回初始化后的实例或相关对象
    return '初始化成功';
    // 在这里写 SDK 初始化逻辑
  } catch (err) {
    console.error("加载失败:", err);
  }
}

// 发送验证码
export function postSmsSendEvent(data) {
  let postData = {
    "appId": envConfig.appId,
    "phoneNumber":data.phoneNumber,
    "areaCode":data.areaCode,
    "captchaVerification": data.captchaVerification
  }
  return $.postSmsSend(postData, envConfig.baseURL);
}


// 滑块验证
export function initSlideVerify(options) {
  console.log('envConfig',envConfig.baseURL)
  if (!options.baseUrl) {
    options.baseUrl = envConfig.baseURL
  }
  // return $(el).slideVerify(options);
  // console.log('idName',idName)
  return $(`#${idName}`).slideVerify(options);
}

// 点选验证 没封装
// export function initPointsVerify(el, options) {
//   options.baseUrl = envConfig.baseURL
//   return $(el).pointsVerify(options);
// }

// 销毁滑块验证
export function destroySlideVerify() {
  const $el = $(`#${idName}`);
  if ($el.length === 0) return;

  // 1. 移除绑定在节点上的数据和事件
  $el.off();          // 移除 jQuery 事件
  $el.removeData();   // 移除 jQuery 存储的数据

  // 2. 清空节点内容
  $el.empty();

  // 3. 可选：彻底删除节点
  $el.remove();

  // console.log(`slideVerify #${idName} 已销毁`);
}


// WEBPACK FOOTER //
// ./src/utils/verify-sdk/index.js